.defaultBorder {
	border: 1px solid black;
}

.topMarginThirty {
	margin-top: 30px !important;
}

.defaultBorderWithPaddingTwenty {
	border: 1px solid black;
	padding: 20px !important;
}

.titleBackground {
	background-color: var(--title-background);
}

.customPadding {
	padding-top: 20px !important;
	padding-bottom: 20px !important;
	padding-left: 50px !important;
	padding-right: 50px !important;
}

.customStyleForKvkkCheck {
	margin-top: -7px !important;
	margin-left: -1px !important;
	align-items: left;
	text-align: left;
	display: inline-block;
}

.customKvkkText {
	font-size: 16px !important;
	vertical-align: middle;
	margin-left: -15px !important;
}

.fontBoldWithMargin {
	font-weight: bold !important;
	margin-top: 5px !important;
	margin-bottom: 5px !important;
}
